<template>
  <div class="detail">
    <headd :mobile_title="mobile_title"></headd>
    <div class="order_detail_box container">
      <div class="box_head">
        <div class="head_title ">订单详情</div>
        <div class="head_icon">
          <img src="../../../static/order/icon_4.png" />
        </div>
      </div>
      <div class="info">
        <div class="name">
          {{ orderinfo.title }}
          <div
            class="head_status status2"
            v-if="orderinfo.order_status == 'unpay'"
          >
            待付款
          </div>
          <div
            class="head_status status1"
            v-if="orderinfo.order_status == 'pending'"
          >
            待处理
          </div>
          <div
            class="head_status status1"
            v-if="orderinfo.order_status == 'processing'"
          >
            办理中
          </div>
          <div
            class="head_status status3"
            v-if="orderinfo.order_status == 'success'"
          >
            已完结
          </div>
          <div
            class="head_status status3"
            v-if="orderinfo.order_status == 'closed'"
          >
            已关闭
          </div>
        </div>
        <div class="option" v-if="orderinfo.option || orderinfo.otheroption">
          <div class="title">选项:</div>
          <div class="content">
            <div>{{ orderinfo.option }}</div>
            <div>{{ orderinfo.otheroption }}</div>
          </div>
        </div>
        <div class="option">
          <div class="title">订单号:</div>
          <div class="content">
            <div>{{ orderinfo.out_trade_no }}</div>
          </div>
        </div>
        <div class="option">
          <div class="title">支付状态:</div>
          <div class="content">
            <div>{{ orderinfo.pay_status == 1 ? "已支付" : "未支付" }}</div>
          </div>
        </div>

        <div class="option" v-if="orderinfo.pay_type != '未知'">
          <div class="title">支付方式:</div>
          <div class="content">
            <div>{{ orderinfo.pay_type }}</div>
          </div>
        </div>
        <div class="option" v-if="orderinfo.payAt">
          <div class="title">支付时间:</div>
          <div class="content">
            <div>{{ orderinfo.payAt }}</div>
          </div>
        </div>
        <div class="option">
          <div class="title">下单时间:</div>
          <div class="content">
            <div>{{ orderinfo.createdAt }}</div>
          </div>
        </div>
        <div class="option" v-if="orderinfo.coupon_discount > 0">
          <div class="title">优惠金额:</div>
          <div class="content">
            <div>
              <span class="red">{{ orderinfo.coupon_discount }}</span
              >元
            </div>
          </div>
        </div>
        <div class="option">
          <div class="title">订单金额:</div>
          <div class="content">
            <div>{{ orderinfo.order_price }}元</div>
          </div>
        </div>
        <div class="price">
          <div class="title">付款金额:</div>
          <div class="content">
            <div>
              <div>
                <span class="span">{{ orderinfo.pay_price }}</span
                >元
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="info">
        <div
          style="flex-direction: column;"
          v-if="orderinfo.order_status == 'unpay'"
        >
          <div class="name">请选择支付方式</div>
          <div class="pay_type">
            <div
              class="type_item"
              v-for="(item, index) in items"
              :key="item.value"
            >
              <div class="type_name">
                <div class="type_icon">
                  <img
                    :src="'../../../static/order/pay_' + item.value + '.png'"
                  />
                </div>
                {{ item.name }}
                <div v-if="item.name == '余额'">
                  ({{ orderinfo.userbalance }}元)
                </div>
              </div>
              <div>
                <input
                  class="radio"
                  type="radio"
                  id="type"
                  :value="item.value"
                  :checked="index === current"
                  v-model="paytype"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="btn_list">
          <div class="bbtn btnzx" @click="kefu">客服咨询</div>
          <div
            class="bbtn btngm"
            v-if="orderinfo.order_status == 'unpay'"
            @click="payorder"
          >
            立即支付
          </div>
        </div>
      </div>
    </div>
    <div class="order_detail_box container" v-if="orderinfo.openRegButton == 1">
      <div class="box_head">
        <div class="head_title">处理事项</div>
        <div class="head_icon">
          <img src="../../../static/order/icon_4.png" />
        </div>
        <!-- <view class="head_status">暂无代办</view> -->
      </div>
      <div class="daiban">
        <div class="p">
          线上签字
        </div>
        <div class="btn_list">
          <div class="btn" @click="golink('1')">登记注册身份验证APP</div>
          <div class="btn" @click="golink('2')">一窗通APP</div>
        </div>
        <div class="upload" v-show="upload">
          <view class="upload_name">开始办理</view>
          <view class="upload_btn">点击开始办理</view>
        </div>
        <div class="upload" v-show="upload">
          <div class="upload_name">核名表提交</div>
          <div class="upload_btn">
            <img src="../../../static/order/icon_5.png" class="icon" /> 上传文件
          </div>
        </div>
        <div class="upload_tip" v-show="upload">
          支持扩展名：rar、zip、doc、docx、pdf、jpg
        </div>
        <div class="upload_save" v-show="upload">提交</div>
      </div>
    </div>
    <div
      class="order_detail_box container"
      v-if="orderinfo.openshangbiaoForm == 1"
    >
      <div class="box_head">
        <div class="head_title">处理事项</div>
        <div class="head_icon">
          <img src="../../../static/order/icon_4.png" />
        </div>
        <!-- <view class="head_status">暂无代办</view> -->
      </div>
      <div class="daiban">
        <div class="box">
          <div class="dbox_cell">
            <div class="dbox_name">商标名称</div>
            <div class="dbox_input">
              <input
                type="text"
                v-model="shangbiao_title"
                placeholder="请输入"
                class="input"
              />
            </div>
          </div>
          <div class="dbox_cell">
            <div class="dbox_name">商标分类</div>
            <div class="dbox_input">
              <select
                v-model="shangbiaoSelected"
                class="select"
                @change="getshangbiaoSelected($event)"
                ><option v-for="item in shangbiaoSelect">{{
                  item.selecttitle
                }}</option></select
              >
            </div>
          </div>
          <div class="dbox_cell">
            <div class="dbox_name">需求描述</div>
            <div class="dbox_input">
              <textarea
                class="textarea"
                v-model="shangbiao_desc"
                placeholder="请输入"
              ></textarea>
            </div>
          </div>
          <div class="dbox_cell">
            <div class="dbox_name">商标图样</div>
            <div
              class="dbox_upload"
              v-for="(item, index) in sbForm.imgJson"
              :key="index"
              @click="delImg"
              :data-index="index"
              :style="{
                backgroundImage: 'url(' + www + item.thumbfilepath + ')'
              }"
            >
              <img class="delete" src="../../../static/circle/icon_10.png" />
            </div>
            <div
              class="dbox_upload"
              @click="setImgarr"
              v-show="sbForm.imgJson.length < 1"
            >
              <div class="upload">
                <img src="../../../static/ruzhu/icon.png" />
              </div>
              <div class="upload_text">请上传</div>
            </div>
          </div>
          <div class="btn_save" @click="shangbiaoForm">提交</div>
        </div>
      </div>
    </div>
    <div
      class="order_detail_box container"
      v-if="orderinfo.processDetailArr != ''"
    >
      <div class="box_head">
        <div class="head_title">办理进度</div>
        <div class="head_icon">
          <img src="../../../static/order/icon_4.png" />
        </div>
      </div>
      <div class="rate">
        <div
          class="rate_list"
          v-for="(item, index) in orderinfo.processDetailArr"
          :key="index"
        >
          <div class="rate_line">
            <div class="i"></div>
          </div>
          <div class="rate_msg">
            <div class="msg_head">
              {{ item.process_title }}
              <div class="time">{{ item.createdAt }}</div>
            </div>
            <div class="msg_con">
              <div
                class="con_cell"
                v-if="item.process != ''"
                v-html="item.process"
              ></div>
              <div class="img_list" v-if="item.imgUrlJson != ''">
                <div
                  class="img_item"
                  :key="index"
                  v-for="(item2, index) in JSON.parse(item.imgUrlJson)"
                  :style="{ backgroundImage: 'url(' + item2.filepath + ')' }"
                >
                  <!-- <img
                    class="img_url"
                    :src="item2.filepath"
                    @tap="_previewImage(item2.filepath)"
                  /> -->
                  <el-image
                    class="my-img"
                    v-if="item2.filepath"
                    :src="item2.filepath"
                    :preview-src-list="[item2.filepath]"
                  >
                  </el-image>
                  <!-- <view class="img_name">公章</view> -->
                </div>
              </div>
              <div class="file_list" v-if="item.fileUrlJson != ''">
                <div
                  class="img_item"
                  :key="index"
                  v-for="(item2, index) in JSON.parse(item.fileUrlJson)"
                  style="flex-direction: row;"
                >
                  <!-- <view class="file_name">{{item2.showname?item2.showname:item2.filename}} </view> -->
                  <div class="file_name">
                    {{ item2.showname ? item2.showname : "文件" }}
                  </div>
                  <div class="file_view" @click="downfile(item2.filepath)">
                    查看
                  </div>
                </div>
              </div>
              <div class="con_cell con_op">操作人：{{ item.opt_nickname }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <foot></foot>
    <el-dialog
      :visible.sync="dialogFormVisible_2"
      :before-close="handleClose"
      width="6rem"
    >
      <div class="code_con">
        <div class="qr_tip">
          <span>使用微信扫码支付</span>
        </div>
        <div id="qrCode" ref="qrCodeDiv"></div>
        <div class="qr_btn" @click="qr_btn">完成</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Loading } from "element-ui";
let inputElement = null;
import axios from "axios";
import {
  getmyOrderDetail,
  getkefuchannel,
  getorderSecPayment,
  getshangbiaoForm
} from "../api/api"; //引入api里面定义的方法
import headd from "@/components/head";
import foot from "@/components/foot";
import QRCode from "qrcodejs2";
import { MessageBox, Toast } from "mint-ui";
export default {
  data() {
    return {
      dialogFormVisible_2: false,
      mobile_title: "订单详情",
      shangbiaoSelected: "请选择",
      index: 0,
      items: [
        {
          value: "1",
          name: "支付宝"
        },
        {
          value: "2",
          name: "微信"
        },
        {
          value: "3",
          name: "余额"
        }
      ],
      type: ["alipay", "wxpcpay", "balancepay"],
      current: 0,
      upload: false,
      orderid: 0,
      orderinfo: {},
      shangbiao_title: "",
      shangbiao_type: "",
      shangbiao_desc: "",
      sbForm: {
        shangbiao_title: "",
        shangbiao_type: "",
        shangbiao_desc: "",
        imgJson: []
      },
      shangbiaoSelect: [],
      paytype: "1",
      www: this.common.www_img,
      apiurl: this.common.apiurl,
      mobile: false
    };
  },
  components: {
    headd,
    foot
  },
  mounted() {
    this.getOrderDetail();
    if (this.isWeiXin()) {
      this.items = [
        {
          value: "2",
          name: "微信"
        },
        {
          value: "3",
          name: "余额"
        }
      ];
      this.paytype = "2";
      this.mobile = true;
    } else {
      this.items = [
        {
          value: "1",
          name: "支付宝"
        },
        {
          value: "2",
          name: "微信"
        },
        {
          value: "3",
          name: "余额"
        }
      ];
      this.paytype = "1";
      this.mobile = false;
    }
  },
  methods: {
    //判断是否是微信浏览器的函数
    isWeiXin() {
      //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      var ua = window.navigator.userAgent.toLowerCase();
      //alert(JSON.stringify(ua));
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    handleClose() {
      console.log(123);
      this.dialogFormVisible_2 = false;
      document.getElementById("qrCode").innerHTML = "";
    },
    qr_btn() {
      this.$router.push({
        name: "order_list"
      });
    },
    getshangbiaoSelected(e) {
      var _self = this;
      _self.shangbiao_type = e.target.value;
    },
    async getkefuchannel() {
      var _self = this;
      var data = { uid: localStorage.getItem("userId") };
      const res = await getkefuchannel(data);
      console.log(res);
      if (res.data.status == 1) {
        return res.data.data.kfid;
      }
    },

    radioChange: function(evt) {
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].value === evt.target.value) {
          this.current = i;
          break;
        }
      }
    },
    _previewImage(image) {
      var imgArr = [];
      imgArr.push(image);
      //预览图片
      uni.previewImage({
        urls: imgArr,
        current: imgArr[0]
      });
    },
    async getOrderDetail() {
      var _self = this;
      var parm = this.$route.query;
      var data = {
        uid: localStorage.getItem("userId"),
        orderid: parm.id
      };

      const res = await getmyOrderDetail(data);
      _self.orderinfo = res.data.data;
      if (res.data.data.shangbiaoSelect) {
        _self.shangbiaoSelect = [
          {
            selecttitle: "请选择",
            selectvalue: "请选择"
          },
          ...res.data.data.shangbiaoSelect
        ];
      }

      //console.log(_self.shangbiaoSelect)
    },
    bindPickerChange(e) {
      var _self = this;
      var index = e.detail.value;
      console.log(index);
      _self.index = e.detail.value;
      _self.sbForm.shangbiao_type = _self.shangbiaoSelect[index].selectvalue;
      // _self.otherindex = e.detail.value
      // _self.otheroption = _self.otheroption_array[index]
    },
    downfile(urlnew) {
      let url = urlnew;
      window.open(url);
      //   this.$refs.lFile.download(url, "local").then(path => {
      //     console.log(path);
      //     //this.localPath = path;
      //     this.$refs.lFile.open(path);
      //   });
    },
    payorder() {
      var _self = this;
      //支付宝支付
      var query = this.$route.query;
      _self.orderid = query.id;

      if (_self.type[_self.paytype - 1] == "alipay") {
        var parm = [
          {
            name: "uid",
            value: localStorage.getItem("userId")
          },
          {
            name: "orderid",
            value: query.id
          },

          {
            name: "pay_type",
            value: "alipay"
          },

          {
            name: "sessionToken",
            value: localStorage.getItem("sessionToken")
          }
        ];

        //模拟form表单
        var temp_form = document.createElement("form");
        temp_form.action =
          "https://mscyeserver.mscye.com/webstf.php/webStfapi/orderSecPayment";
        //如需打开新窗口，form的target属性要设置为'_blank'
        temp_form.target = "_self";
        temp_form.method = "post";
        temp_form.style.display = "none";
        //添加参数
        for (var item in parm) {
          var opt = document.createElement("textarea");
          //console.log(parm[item].name);
          opt.name = parm[item].name;
          opt.value = parm[item].value;
          temp_form.appendChild(opt);
        }
        document.body.appendChild(temp_form);
        //提交数据
        temp_form.submit();
      } else if (_self.type[_self.paytype - 1] == "wxpcpay") {
        if (_self.mobile) {
          var parm = {
            uid: localStorage.getItem("userId"),
            openid: localStorage.getItem("openid"),
            orderid: query.id,
            pay_type: "wxjspay"
          };
          _self.pay_weixin_mobile(parm);
        } else {
          var parm = {
            uid: localStorage.getItem("userId"),
            orderid: query.id,
            pay_type: "wxpcpay"
          };
          _self.pay_weixin(parm);
        }
      } else if (_self.type[_self.paytype - 1] == "balancepay") {
        var info = _self.info;
        //console.log(_self.current_2)
        var parm = {
          uid: localStorage.getItem("userId"),
          orderid: query.id,
          pay_type: "balancepay"
        };
        _self.pay_y(parm);
      }
    },
    async pay_weixin_mobile(parm) {
      var _self = this;
      const res = await getorderSecPayment(parm);
      var data = JSON.parse(res.data.payStr);
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            onBridgeReady,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
        }
      } else {
        _self.onBridgeReady(data);
      }
    },
    onBridgeReady(data) {
      var _self = this;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: "" + data.appId,
          timeStamp: "" + data.timeStamp,
          nonceStr: "" + data.nonceStr,
          package: "" + data.package,
          signType: "" + data.signType,
          paySign: "" + data.paySign
        },
        function(res) {
          console.log(res);
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            var query = _self.$route.query;
            _self.$router.push({
              path: "pay",
              query: {
                pay_status: "s",
                orderid: query.id
              }
            });

            // this.$router.push({
            //   path: "/"
            // });
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          } else {
            var query = _self.$route.query;
            _self.$router.push({
              path: "pay",
              query: {
                pay_status: "f",
                orderid: query.id
              }
            });
          }
        }
      );
    },
    async pay_weixin(parm) {
      var _self = this;
      const res = await getorderSecPayment(parm);
      console.log(JSON.parse(res.data.payStr).code_url);
      _self.dialogFormVisible_2 = true;
      _self.$nextTick(function() {
        var qrcode = new QRCode(this.$refs.qrCodeDiv, {
          text: JSON.parse(res.data.payStr).code_url,
          width: 200,
          height: 200,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H
        });
      });
    },
    async pay_y(parm) {
      console.log(parm);
      const res = await getorderSecPayment(parm);
      console.log(res);
      var orderid = res.data.orderid;
      if (res.status == 1) {
        this.$toast({
          message: "支付成功",
          type: "success"
        });
        this.$router.push({
          path: "pay",
          query: {
            pay_status: "s",
            orderid: orderid
          }
        });
      } else {
        this.$toast(res.msg);
        this.$router.push({
          path: "pay",
          query: {
            pay_status: "f",
            orderid: orderid
          }
        });
      }
    },
    async pay(parm) {
      var _self = this;
      console.log(parm);
      const res = await this.$myRuquest({
        url: "/orderSecPayment",
        data: parm,
        method: "POST"
      });
      console.log(res.data);
      var orderid = res.data.data.orderid;
      if (res.data.status == 1) {
        if (_self.type[_self.current] == "alipay") {
          uni.requestPayment({
            provider: "alipay", //服务提供商（支付宝）（服务提供商，通过uni.getProvider获取）
            orderInfo: res.data.data.payStr, //后台返回的支付宝订单数据
            success(res) {
              //console.log('success:' + JSON.stringify(res));
              uni.navigateTo({
                url: "../pay/pay?pay_status=t&orderid=" + orderid
              });
            },
            fail(err) {
              //console.log('fail:' + JSON.stringify(err));
              uni.navigateTo({
                url: "../pay/pay?pay_status=f&orderid=" + orderid
              });
            }
          });
        } else if (_self.type[_self.current] == "wxpay") {
          uni.requestPayment({
            provider: "wxpay", //服务提供商（支付宝）（服务提供商，通过uni.getProvider获取）
            orderInfo: JSON.parse(res.data.data.payStr), //后台返回的支付宝订单数据
            success(res) {
              //console.log('success:' + JSON.stringify(res));
              uni.navigateTo({
                url: "../pay/pay?pay_status=t&orderid=" + orderid
              });
            },
            fail(err) {
              //console.log('fail:' + JSON.stringify(err));
              uni.navigateTo({
                url: "../pay/pay?pay_status=f&orderid=" + orderid
              });
            }
          });
        }
      }
    },
    async shangbiaoForm() {
      var _self = this;
      var data = _self.sbForm;
      console.log(data);
      if (_self.shangbiao_title == "") {
        this.$toast("请输入商标名称");

        return false;
      }
      if (_self.shangbiao_type == "请选择") {
        this.$toast("请选择分类");

        return false;
      }
      if (_self.shangbiao_desc == "") {
        this.$toast("请输入需求备注");

        return false;
      }
      var query = this.$route.query;
      var parm = {
        uid: localStorage.getItem("userId"),
        orderid: query.id,
        shangbiao_title: _self.shangbiao_title,
        shangbiao_type: _self.shangbiao_type,
        shangbiao_desc: _self.shangbiao_desc,
        imgJson: JSON.stringify(_self.sbForm.imgJson)
      };
      console.log(parm);
      const res = await getshangbiaoForm(parm);

      if (res.status == 1) {
        this.$toast({
          message: "提交成功",
          type: "success"
        });
        _self.getOrderDetail();
        _self.shangbiao_title = "";
        _self.shangbiao_desc = "";
        _self.shangbiao_type = "";
        _self.sbForm.imgJson = [];
      }
    },
    getTitle(e) {
      var that = this;
      that.setValue(e.detail.value, "shangbiao_title");
    },
    getDesc(e) {
      var that = this;
      that.setValue(e.detail.value, "shangbiao_desc");
    },
    setValue(v, key) {
      var that = this;
      var tmpData = that.sbForm;
      tmpData[key] = v;
      that.sbForm = tmpData;
    },
    setImgarr() {
      var that = this;
      if (inputElement === null) {
        // 生成文件上传的控件
        inputElement = document.createElement("input");
        inputElement.setAttribute("type", "file");
        inputElement.style.display = "none";

        if (window.addEventListener) {
          inputElement.addEventListener("change", this.uploadFile, false);
        } else {
          inputElement.attachEvent("onchange", this.uploadFile);
        }

        document.body.appendChild(inputElement);
      }
      inputElement.click();
    },
    uploadFile(el) {
      var _self = this;
      var loadingInstance1 = Loading.service({ fullscreen: true });
      if (el && el.target && el.target.files && el.target.files.length > 0) {
        console.log(el);
        const files = el.target.files[0];
        const isLt2M = files.size / 1024 / 1024 < 50;
        const size = files.size / 1024 / 1024;
        //console.log(size);
        // 判断上传文件的大小
        if (!isLt2M) {
          this.$toast("上传图片大小不能超过 50MB!");
        } else if (files.type.indexOf("image") === -1) {
          //如果不是图片格式
          // this.$dialog.toast({ mes: '请选择图片文件' });
          this.$toast("请选择图片文件");
        } else {
          const that = this;
          const reader = new FileReader(); // 创建读取文件对象
          console.log(el.target.files[0]);
          reader.readAsDataURL(el.target.files[0]); // 发起异步请求，读取文件
          reader.onload = function() {
            // 文件读取完成后
            // 读取完成后，将结果赋值给img的src
            that.valueUrl = this.result;
            //console.log(_self.dataURLtoBlob(this.result));

            // 数据传到后台
            const formData = new FormData();
            formData.append("orderimg", files, files.name); // 通过append向form对象添加数据,可以通过append继续添加数据//或formdata1.append('img',file);
            let config = {
              headers: { "Content-Type": "multipart/form-data" }
            };
            axios
              .post(that.apiurl + "/uploadOrderImg", formData, config)
              .then(uploadFileRes => {
                //console.log(uploadFileRes.data);
                //var res = JSON.parse(uploadFileRes.data);
                //console.log(res.data);
                //var res = JSON.parse(uploadFileRes.data);
                //console.log(res.data);
                var res = uploadFileRes.data;
                console.log(res);
                if (res.status == 1) {
                  _self.sbForm.imgJson.push(uploadFileRes.data.data);
                } else {
                  that.$toast(res.msg);
                }
                that.$nextTick(() => {
                  // 以服务的方式调用的 Loading 需要异步关闭
                  loadingInstance1.close();
                });

                inputElement = null;
              });
          };
        }
      }
    },
    delImg(e) {
      //console.log(e)
      var _self = this;
      var index = e.currentTarget.dataset.index;
      MessageBox.confirm("是否删除图片")
        .then(action => {
          Toast({
            message: "删除成功"
          });
          var imgJson = _self.sbForm.imgJson;
          imgJson.splice(index, 1);
          _self.sbForm.imgJson = imgJson;
        })
        .catch(() => {
          Toast({
            message: "已取消删除"
          });
        });
    },
    golink(url) {
      if (url == "1") {
        window.open(
          "https://a.app.qq.com/o/simple.jsp?pkgname=gov.zwfw.samr.djzc&g_f=1000047",
          "_blank"
        );
      } else if (url == "2") {
        window.open(
          "https://a.app.qq.com/o/simple.jsp?pkgname=com.sheca.gsyct&g_f=1000047",
          "_blank"
        );
      }
    },
    kefu() {
      var uid = localStorage.getItem("userId");
      var recipient_id = this.orderinfo.recipient_id;
      // uni.navigateTo({
      // 	url: '../chat/chat?uid=' + uid + '&recipient_id=' + recipient_id
      // })

      if (recipient_id == 0) {
        console.log(recipient_id);
        _self.getkefuchannel().then(function(result) {
          console.log(result);
          recipient_id = result;
          this.$router.push({
            path: "chat",
            query: {
              uid: uid,
              recipient_id: recipient_id
            }
          });
        });
      } else {
        this.$router.push({
          path: "chat",
          query: {
            uid: uid,
            recipient_id: recipient_id
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.body_back {
  @media (max-width: 991px) {
    background: #f2f2f2;
  }
}

.order_detail_box {
  width: 8rem;
  margin: 0.3rem auto;
  border: 1px solid #c4c4cc;
  height: auto;
  padding: 0;
  background: #ffffff;
  border-radius: 0.2rem;
  flex-direction: column;
  overflow: hidden;
  @media (max-width: 991px) {
    width: 6.86rem;
    margin: 0.3rem auto 0.3rem auto;
  }

  .box_head {
    width: 100%;
    height: auto;
    padding: 0.2rem 0.3rem;
    align-items: center;
    justify-content: space-between;
    border-bottom: 0.01rem solid rgba(196, 196, 204, 0.5);
    position: relative;
    display: flex;

    .head_title {
      font-size: 0.2rem;
      font-weight: bolder;
      color: #1b1c33;
      line-height: 0.3rem;
      position: relative;
      padding-left: 0.1rem;
      @media (max-width: 991px) {
        font-size: 0.3rem;
        line-height: 0.4rem;
      }

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 0.05rem;
        height: 0.26rem;
        background: url(../../../static/order/icon_3.png) no-repeat;
        background-size: 0.05rem 0.26rem;
        @media (max-width: 991px) {
          top: 0.08rem;
          width: 0.04rem;
          height: 0.26rem;
        }
      }
    }

    .head_icon {
      width: 0.2rem;
      height: 0.11rem;
      @media (max-width: 991px) {
        width: 0.3rem;
        height: 0.16rem;
        display: flex;
        align-items: center;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }

    .head_status {
      position: absolute;
      top: 0.27rem;
      right: 0.6rem;
      font-size: 0.26rem;
      line-height: 0.26rem;
      color: #1395ff;
    }
  }
  .item_head {
    width: 100%;
    border-bottom: 0.01rem solid rgba(196, 196, 204, 0.2);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0.22rem 0.3rem;
    height: auto;

    .head_info {
      display: flex;
      align-items: center;
      .info_icon {
        width: 0.28rem;
        height: 0.26rem;
        margin-right: 0.11rem;
        display: flex;
        align-items: center;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .info_type {
        font-size: 0.24rem;
        color: #1b1c33;
        line-height: 0.3rem;
      }
    }
  }

  .info {
    flex-direction: column;
    width: 100%;
    padding: 0.3rem 0.3rem;
    overflow: hidden;
    //border-bottom: 1rpx solid rgba(196, 196, 204, 0.5);

    .name {
      font-size: 0.24rem;
      font-weight: bolder;
      color: #1b1c33;
      margin-bottom: 0.2rem;
      justify-content: space-between;
      align-items: center;
      height: auto;
      display: flex;
      @media (max-width: 991px) {
        font-size: 0.3rem;
      }

      .head_status {
        margin-top: 0.02rem;
        width: 0.96rem;
        height: 0.38rem !important;
        border-radius: 0.2rem !important;
        font-size: 0.16rem;
        text-align: center;
        line-height: 0.38rem !important;
        align-items: center;
        justify-content: center;
        font-weight: normal;
        @media (max-width: 991px) {
          width: 1.26rem !important;
          font-size: 0.24rem;
        }
      }

      .head_status.status1 {
        border: 1px solid #1395ff;
        color: #1395ff;
      }

      .head_status.status2 {
        border: 1px solid #ff545a;
        color: #ff545a;
      }

      .head_status.status3 {
        border: 1px solid #8d8e99;
        color: #8d8e99;
      }
    }

    .option {
      flex-direction: row;
      margin-bottom: 0.2rem;
      display: flex;

      .title {
        font-size: 0.16rem;
        color: #8d8e99;
        line-height: 0.25rem;
        width: 0.96rem;
        @media (max-width: 991px) {
          width: 1.26rem;
          font-size: 0.28rem;
          line-height: 0.36rem;
        }
      }

      .content {
        flex-direction: column;
        font-size: 0.16rem;
        color: #444649;
        line-height: 0.25rem;
        @media (max-width: 991px) {
          font-size: 0.28rem;
          line-height: 0.36rem;
        }

        div {
          margin-bottom: 0.15rem;
          flex-direction: row;

          &:last-child {
            margin-bottom: 0;
          }

          .red {
            color: rgba(255, 84, 90, 1);
          }

          .status {
            margin-left: 0.32rem;
            font-weight: 600;
            color: #1395ff;
          }
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    .price {
      margin-top: 0.21rem;
      font-size: 0.16rem;
      font-weight: bolder;
      color: #1b1c33;
      line-height: 0.25rem;
      display: flex;
      .span {
        margin-left: 0.1rem;
        color: #ff545a;
      }
      @media (max-width: 991px) {
        font-size: 0.3rem;
        line-height: 0.42rem;
      }
    }

    .pay_type {
      width: 100%;

      radio-group {
        width: 100%;
      }

      .type_item {
        justify-content: space-between;
        width: 100%;
        align-items: center;
        margin-bottom: 0.4rem;
        display: flex;

        .type_name {
          font-size: 0.16rem;
          color: #1b1c33;
          display: flex;
          align-items: center;
          @media (max-width: 991px) {
            font-size: 0.28rem;
          }

          .type_icon {
            width: 0.3rem;
            height: 0.3rem;
            margin-right: 0.1rem;
            display: flex;
            align-items: center;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .radio {
          width: 0.24rem;
          height: 0.24rem;
          @media (max-width: 991px) {
            width: 0.28rem;
            height: 0.28rem;
          }
        }
      }
    }

    .btn_list {
      justify-content: space-around;
      display: flex;
      flex-wrap: wrap;

      .bbtn {
        width: 2.6rem;
        height: 0.7rem;
        font-size: 0.24rem;
        color: #ffffff;
        line-height: 0.7rem;
        justify-content: center;
        align-items: center;
        border-radius: 0.4rem;
        text-align: center;
        cursor: pointer;
        @media (max-width: 991px) {
          font-size: 0.3rem;
        }
      }

      .bbtn.btnzx {
        background-color: #1395ff;
      }

      .bbtn.btngm {
        background-color: #f4556c;
      }
    }
  }

  .daiban {
    padding: 0rpx;
    flex-direction: column;

    .p {
      margin: 0.4rem 0.7rem;
      font-size: 0.2rem;
      color: #1b1c33;
      @media (max-width: 991px) {
        font-size: 0.26rem;
      }
    }

    .upload {
      justify-content: space-between;
      margin-bottom: 0.2rem;
      position: relative;

      .upload_name {
        font-size: 0.28rem;
        color: #1b1c33;
      }

      .upload_btn {
        width: 2.6rem;
        height: 0.44rem;
        border-radius: 0.22rem;
        border: 0.01rem solid #1395ff;
        font-size: 0.26rem;
        color: #1395ff;
        align-items: center;
        justify-content: center;

        .icon {
          width: 0.11rem;
          height: 0.14rem;
          margin-right: 0.1rem;
        }
      }
    }

    .upload_tip {
      font-size: 0.26rem;
      color: #1395ff;
      text-align: right;
      justify-content: flex-end;
    }

    .upload_save {
      margin: 0.6rem auto 0 auto;
      width: 5.9rem;
      height: 0.8rem;
      background: url(../../../static/order/btn_3.png) no-repeat;
      background-size: 5.9rem 0.8rem;
      font-size: 0.36rem;
      color: #ffffff;
      line-height: 0.8rem;
      justify-content: center;
      align-items: center;
    }

    .btn_list {
      justify-content: center;
      margin-bottom: 0.4rem;
      text-align: center;

      .btn {
        text-align: center;
        font-size: 0.24rem;
        font-family: PingFangSC-Medium, PingFang SC;
        color: #1395ff;
        line-height: 0.7rem;
        height: 0.7rem;
        border-radius: 0.35rem;
        border: 0.02rem solid #1395ff;
        padding: 0rem 0.31rem;
        margin: 0 0.09rem;
        @media (max-width: 991px) {
          font-size: 0.28rem;
        }
      }
    }

    .box {
      margin: 0.4rem 0.7rem;

      height: auto;
      flex-direction: column;

      .box_title {
        font-size: 0.38rem;
        line-height: 0.38rem;
        margin-bottom: 0.4rem;
        align-items: center;

        .title_icon {
          width: 0.32rem;
          height: 0.33rem;
          margin-right: 0.1rem;
        }
      }

      .dbox_cell {
        align-items: center;
        justify-content: flex-start;
        margin: 0 0.4rem 0.4rem 0rem;
        display: flex;

        .dbox_name {
          width: 1.25rem;
          height: 0.25rem;
          font-size: 0.18rem;
          color: #5e5e66;
          line-height: 0.25rem;
          text-align: justify;
          display: inline-block;
          @media (max-width: 991px) {
            font-size: 0.28rem;
            line-height: 0.3rem;
            height: auto;
          }
          // text-align-last: justify;
        }

        .img_list {
          flex-wrap: wrap;
          width: 5.23rem;
          padding: 0.2rem;
          background: rgba(196, 196, 204, 0.1);
          border-radius: 0.12rem;
          display: flex;

          .img_item {
            flex-direction: column;
            margin-right: 0.2rem;
            margin-bottom: 0.2rem;
            width: 1rem;
            height: 1rem;
            border: 0.01rem solid #979797;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            align-items: center;
            border-radius: 0.12rem;
            background-color: #fff;
            justify-content: center;
            display: flex;
            position: relative;

            .item_icon {
              width: 0.3rem;
              height: 0.29rem;
            }

            .img_url {
              width: 1.6rem;
              height: 1.6rem;
              margin-bottom: 0.2rem;
              opacity: 0;
            }

            .img_name {
              text-align: center;
              font-size: 0.26rem;
              line-height: 0.26rem;
              font-family: PingFangSC-Regular, PingFang SC;
              color: #1b1c33;
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .delete {
              position: absolute;
              top: -0.15rem;
              right: -0.15rem;
              width: 0.4rem;
              height: 0.4rem;
              z-index: 2;
            }
          }
        }

        .dbox_input {
          flex: 1;
          .input {
            width: 100%;
            border: 0.01rem solid #c4c4cc;
            background: #fff;
            font-size: 0.18rem;
            line-height: 0.25rem;
            padding: 0.17rem;
            color: #333;
            @media (max-width: 991px) {
              font-size: 0.28rem;
              line-height: 0.3rem;
              height: auto;
            }
          }

          .textarea {
            width: 100%;
            font-size: 0.18rem;
            color: #333;
            line-height: 0.25rem;
            padding: 0.17rem;
            border: 0.01rem solid #c4c4cc;
            background: #fff;
            resize: none;
            @media (max-width: 991px) {
              font-size: 0.28rem;
              line-height: 0.3rem;
              height: auto;
            }
          }

          .select {
            width: 100%;
            padding: 0.1rem 0.17rem;
            border: 0.01rem solid #c4c4cc;
            background: #fff;
            font-size: 0.18rem;
            align-items: center;
            justify-content: flex-start;
            @media (max-width: 991px) {
              font-size: 0.28rem;
              height: 0.84rem;
              padding: 0.17rem;
              line-height: 100%;
            }
          }
        }

        .dbox_upload {
          width: 2.23rem;
          padding: 0.2rem;
          height: 1.23rem;
          background: rgba(196, 196, 204, 0.1);
          border-radius: 0rem;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          position: relative;
          background-size: cover;
          background-position: center;
          text-align: center;
          display: flex;

          .upload {
            width: 1rem;
            height: 0.83rem;
            margin-bottom: 0.23rem;

            img {
              width: 0.5rem;
              height: 0.42rem;
            }
          }

          .upload_text {
            height: 0.25rem;
            font-size: 0.16rem;
            color: #1b1c33;
            line-height: 0.25rem;
            @media (max-width: 991px) {
              font-size: 0.28rem;
              line-height: 0.3rem;
              height: auto;
            }
          }

          .upload_tip {
            height: 0.42rem;
            font-size: 0.3rem;
            color: #8d8e99;
            line-height: 0.42rem;
          }

          .delete {
            position: absolute;
            top: -0.15rem;
            right: -0.15rem;
            width: 0.4rem;
            height: 0.4rem;
            z-index: 2;
          }
        }
      }

      .btn_save {
        margin: 0.5rem auto 0.5rem auto;
        width: 2.94rem;
        height: 0.7rem;
        line-height: 0.7rem;
        background: #1395ff;
        border-radius: 0.35rem;
        font-size: 0.24rem;
        color: #ffffff;
        align-items: center;
        justify-content: center;
        text-align: center;
        cursor: pointer;
        @media (max-width: 991px) {
          font-size: 0.28rem;
        }
      }
    }
  }

  .rate {
    margin: 0.3rem 0.3rem;
    flex-direction: column;

    .rate_list {
      //align-items: center;
      position: relative;
      min-height: 1.4rem;
      display: flex;

      .rate_line {
        width: 0.4rem;
        text-align: center;

        .i {
          margin-top: 0.2rem;
          margin-left: 0rem;
          border-radius: 50%;
          width: 0.2rem;
          height: 0.2rem;
          background: #1395ff;
          z-index: 1;
        }
      }

      .rate_msg {
        margin-left: 0rem;
        margin-bottom: 0.2rem;
        height: auto;
        border-radius: 0.12rem;
        border: 1px solid rgba(19, 149, 255, 0.5);
        flex-direction: column;
        flex: 1;

        .msg_head {
          padding: 0.1rem 0.2rem;
          font-size: 0.18rem;
          line-height: 0.25rem;
          color: #1395ff;
          border-bottom: 0.01rem solid rgba(19, 149, 255, 0.2);
          align-items: center;
          justify-content: space-between;
          display: flex;
          @media (max-width: 991px) {
            padding: 0.2rem 0.2rem;
            font-size: 0.28rem;
            line-height: 0.3rem;
          }

          .time {
            font-size: 0.14rem;
            line-height: 0.26rem;
            color: #8d8e99;
            @media (max-width: 991px) {
              font-size: 0.26rem;
              line-height: 0.3rem;
            }
          }
        }

        .msg_con {
          padding: 0.2rem;
          font-size: 0.2rem;
          color: #1b1c33;
          flex-direction: column;
          @media (max-width: 991px) {
            font-size: 0.26rem;
          }

          .con_cell {
            font-size: 0.16rem;
            line-height: 0.25rem;
            color: #1b1c33;
            margin-bottom: 0.2rem;
            @media (max-width: 991px) {
              font-size: 0.26rem;
              line-height: 0.3rem;
            }

            &:last-child {
              margin-bottom: 0;
            }
          }

          .con_cell.link {
            color: #1395ff;
          }

          .con_op {
            margin-top: 0.2rem;
          }

          .img_list {
            flex-wrap: wrap;
            margin-bottom: 0.2rem;
            display: flex;

            .img_item {
              flex-direction: column;
              margin-right: 0.2rem;
              margin-bottom: 0.2rem;

              width: 1.2rem;
              //   height: 1.2rem;
              overflow: hidden;
              background-size: cover;
              background-position: center;
              background-repeat: no-repeat;
              border-radius: 0rpx;
              /deep/.el-image__inner {
                width: 1.2rem;
                // height: 1.2rem;
                /* height: 1rem; */
              }

              .img_url {
                width: 1.2rem;
                height: 1.2rem;
                margin-bottom: 0.2rem;
                opacity: 0;
              }

              .img_name {
                text-align: center;
                font-size: 0.2rem;
                line-height: 0.26rem;
                color: #1b1c33;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }
          }

          .file_list {
            flex-wrap: wrap;
            font-size: 0.16rem;
            display: flex;
            @media (max-width: 991px) {
              font-size: 0.26rem;
            }
            .img_item {
              display: flex;
            }

            .file_name {
              margin-right: 0.1rem;
            }

            .file_view {
              cursor: pointer;
              color: #1395ff;
              text-decoration: underline;
            }
          }
        }
      }

      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0.09rem;
        bottom: 0;
        width: 0.02rem;
        background: rgba(19, 149, 255, 1);
      }

      &:last-child {
        .rate_msg {
          margin-bottom: 0rpx;
        }
      }
    }
  }
}
/deep/.el-image__inner {
  width: 1.2rem;
  /* height: 1rem; */
}
.code_con {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .qr_tip {
    font-size: 0.16rem;
    line-height: 0.25rem;
    text-align: center;
    @media (max-width: 991px) {
      font-size: 0.26rem;
      line-height: 0.33rem;
    }
  }
  .qr_btn {
    margin-top: 0.2rem;
    width: 1.26rem;
    height: 0.4rem;
    font-size: 0.24rem;
    line-height: 0.4rem;
    background-color: #1395ff;
    border-radius: 0.2rem;
    color: #ffffff;
    text-align: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/order/order_detail.vue